import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Header from "../Components/Parts/header";
import ActiviteitenWidget from "./Activiteiten/Components/widget";
import FaciliteitenWidget from "./Faciliteiten/Components/widget";
import SensorWidget from "./Sensors/Components/widget";
import SensorWidgetFavo from "./Sensors/Components/favowidget";
import VVVItemsWidget from "./Items/Components/widget";
import ErvaringenWidget from "./Ervaringen/Components/widget";
import BoekingenWidget from "./Boekingen/Components/widget";
import ErvaringenWidgetAankomende from "./Ervaringen/Components/widgetaankomende";
import FavSesnorenWidget from "./Standplaatsen/Kampeerplaatsen/Components/favowidgetMeter";
import FavAccoWidget from "./Standplaatsen/Accommodaties/Components/favowidget";
import { fetchsensoren } from "./Sensors/Reducers/actions";
import Loading from "../Components/loading/load";
import bedrijven from "../Components/Lib/Bedrijven/bedrijven";
import MeterInstellen from "./Standplaatsen/Kampeerplaatsen/Components/MeterInstellen";




const Startpage = ({ user, sensoren, fetchsensoren, history }) => {
  const [load, setLoad] = useState(false);


  useEffect(() => {
    fetchsensoren().then((data) => {
      setLoad(true);
    });
  }, [fetchsensoren]);



  const vaild = (vall) => {
    return vall.includes(user.role);
  };

  const ismodule = (val) => {
    return user.bedrijf && user.bedrijf.modules && user.bedrijf.modules.includes(val);
  };



  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title"> Welkom bij {user && user.bedrijf && user.bedrijf.naam}</h3>
  
      </div>

      <div className="row">
        {vaild(["admin", "manager", "medewerker", "faciliteitmedewerker"]) && ismodule("sensoren") && sensoren.some((sensor) => sensor.favo === true) && (
          <div className="col-md-12">
            <div className="box box-info">
              <div className="box-header with-border">
                <h3 className="box-title">Favoriete sensoren</h3>
            
              </div>
              {load && <SensorWidgetFavo sensoren={sensoren} />}
              <Loading loadings={load} />
            </div>
          </div>
        )}

        {vaild(["admin", "manager", "medewerker", "faciliteitmedewerker", "havenmeester", "receptie"]) && ismodule("kampeerplaatsen") && (
          <div className="col-md-12">
            <div className="box box-info">
              <div className="box-header with-border">
                <h3 className="box-title">{bedrijven("plaatsen")}</h3>
             
              </div>
              {load && <FavSesnorenWidget sensoren={sensoren} />}
              <Loading loadings={load} />
            </div>
          </div>
        )}
        {vaild(["admin", "manager", "medewerker", "faciliteitmedewerker", "receptie"]) && ismodule("accommodaties") && (
          <div className="col-md-12">
            <div className="box box-info">
              <div className="box-header with-border">
                <h3 className="box-title">Accommodaties</h3>
              
              </div>
              {load && <FavAccoWidget sensoren={sensoren} />}
              <Loading loadings={load} />
            </div>
          </div>
        )}

        {vaild(["admin", "manager", "medewerker", "faciliteitmedewerker"]) && ismodule("sensoren") && (
          <div className="col-md-12">
            <div className="box box-info">
              <div className="box-header with-border">
                <h3 className="box-title">Lijst sensoren</h3>
               
              </div>
              {load && <SensorWidget sensoren={sensoren} />}
              <Loading loadings={load} />
            </div>
          </div>
        )}
        {vaild(["admin", "manager", "hoofdrecreatie", "faciliteitmedewerker"]) && ismodule("activiteiten") && (
          <div className="col-xl-6">
            <div className="box box-success">
              <div className="box-header with-border">
                <h3 className="box-title">Activiteiten waar je voor in kan schrijven</h3>
            
              </div>
              <div className="box-body">
                <ActiviteitenWidget />
              </div>
            </div>
          </div>
        )}
        {vaild(["admin", "manager", "hoofdrecreatie", "faciliteitmedewerker"]) && ismodule("faciliteiten") && (
          <div className="col-xl-6">
            <div className="box box-info">
              <div className="box-header with-border">
                <h3 className="box-title">Lijst met Faciliteiten</h3>
          
              </div>
              <div className="box-body">
                <FaciliteitenWidget />
              </div>
            </div>
          </div>
        )}
        {vaild(["admin", "manager", "medewerker", "faciliteitmedewerker"]) && ismodule("items") && (
          <div className="col-xl-6">
            <div className="box box-info">
              <div className="box-header with-border">
                <h3 className="box-title">VVV Items</h3>
           
              </div>
              <div className="box-body">
                <VVVItemsWidget history={history} />
              </div>
            </div>
          </div>
        )}
        {vaild(["admin", "manager", "medewerker", "ervaringeigenaar"]) && ismodule("ervaringen") && (
          <div className="col-xl-6">
            <div className="box box-info">
              <div className="box-header with-border">
                <h3 className="box-title">Aankomende ervaringen</h3>
         
              </div>
              <div className="box-body">
                <ErvaringenWidgetAankomende />
              </div>
            </div>
          </div>
        )}
        {vaild(["admin", "manager", "medewerker", "ervaringeigenaar"]) && ismodule("ervaringen") && (
          <div className="col-md-12">
            <div className="box box-info">
              <div className="box-header with-border">
                <h3 className="box-title">Overzicht nieuwe boekingen</h3>
         
              </div>
              <div className="box-body">
                <BoekingenWidget />
              </div>
            </div>
          </div>
        )}
        {vaild(["admin", "manager", "medewerker", "ervaringeigenaar"]) && ismodule("ervaringen") && (
          <div className="col-md-12">
            <div className="box box-info">
              <div className="box-header with-border">
                <h3 className="box-title">Ervaringen</h3>
           
              </div>
              <div className="box-body">
                <ErvaringenWidget />
              </div>
            </div>
          </div>
        )}

        {vaild(["installateur"]) && ismodule("kampeerplaatsen") && (
          <div className="col-md-12">
            <div className="box box-info">
         
              <div className="box-body">
                <MeterInstellen />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return { user: state.auth.user, sensoren: state.sensoren.items };
}

export default connect(mapStateToProps, { fetchsensoren })(Startpage);
